import { sortOn } from '@timmons-group/shared-react-components/helpers';

export const createZoomOption = (label, value, extent) => ({ label, value, extent });
export const zoomableOption = (item, labelProp = 'label', valueProp = 'id') => {
  return createZoomOption(item[labelProp], item[valueProp], item.fields?.extent);
};

export function zoomablesOptions(zoomables, labelProp = 'label', valueProp = 'id') {
  return sortOn(zoomables, 'label').map((item) => zoomableOption(item, labelProp, valueProp));
}

export const getSectionChoices = (layout, sectionName, modelName) => {
  if (!layout || !layout.sections) {
    return [];
  }

  const section = layout.sections.find(s => s.name === sectionName);
  if (!section?.layout) {
    return [];
  }

  const type = section.layout.find(l => l.model.name === modelName);
  const choices = type?.possibleChoices ? type?.possibleChoices.map(item => ({
    label: item.name,
    id: item.id,
  })) : [];

  return choices;
}

